import './NotFound.scss';
import { Icon } from '../../components/icon/icon';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const NotFound = () => {
  const { t } = useTranslation();
  useDocumentTitle();
  return (
    <div
      className="flex justify-center"
      style={{ height: '100vh', justifyContent: 'center' }}
    >
      <div className="not__found__text">
        <span>{t('Not found')}</span>
        <a href="/">
          <Icon.ICSub width={'24px'} height={'24px'} />
          {t('Back to home')}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
